<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="loan_detail_h1 loan_detail_two_line">
        <span>Apply Time: {{loanAllData.applyDate}}</span>
      </h1>
      <h1 v-if="loanAllData.itemApplyId" class="loan_detail_h1 loan_detail_two_line">
        <span>Loan#: {{loanAllData.itemApplyId}}</span>
      </h1>
      <div class="loan_detail_first">
        <ul class="text-center">
          <li>
            <em>Loan Amount</em>
            <strong>${{loanAllData.loanAmount}}</strong>
          </li>
          <li>
            <em>Status</em>
            <strong>
              {{loanAllData.auditState}}
              <img src="../../../static/images/loan_state.png" alt="Loan Status"/>
            </strong>
          </li>
          <li class="mobile-hide-button">
            <!-- <el-button type="primary" class="btn" @click="showManagerDialog = true">Manager</el-button> -->
            <el-button type="primary" class="btn" @click="showAgreement">View Contract</el-button>
          </li>
        </ul>
      </div>

      <div class="loan_detail_second">
        <ul>
          <li>
            <span>Loan Start Date</span>
            <strong>{{loanAllData.loanSdate}}</strong>
          </li>
          <li>
            <span>Term of Loan</span>
            <strong>{{loanAllData.loanExpires}}</strong>
          </li>
          <!--          <li><span>Bank account</span><strong>{{loanAllData.bankAccountInfo}}</strong></li>-->

          <li v-if="Number(userInfo.crmCustomerType) === 2">
            <span>Business license number</span>
            <strong :title="loanAllData.enterpriseNumber">{{loanAllData.enterpriseNumber}}</strong>
          </li>
          <li>
            <span>Maturity Date</span>
            <strong>{{loanAllData.loanEdate}}</strong>
          </li>
          <li>
            <span>Repayment method</span>
            <strong>{{loanAllData.repayType}}</strong>
          </li>
        </ul>
      </div>

      <div class="loan_detail_three">
        <div class="table-title">
          Repayment Schedule
          <!-- <router-link :to="toWholeRepay" class="btn" tag="button" :disabled="banRepay()">æŒ‰æœŸè¿˜æ¬¾</router-link> -->
          <!-- å±�è”½æ��å‰�è¿˜æ¬¾
					<div class="btn_cont" v-if="Number(userInfo.crmCustomerType) === 1">
						<router-link :to="toPrepayment" class="btn" tag="button" :disabled="banRepay()">Prepay</router-link>
					</div>
          -->
          <div
            class="tips_info el-icon-information"
          >Enterprise users only support offline repaymentï¼�</div>
        </div>
        <el-table
          class="table-body pointer"
          :data="loanAllData.repayInfoList"
          style="width: 100%"
          @row-click="roRepaymentInfo"
        >
          <el-table-column prop="period" label="Term" width="70">
            <template slot-scope="scope">
              <span class="item_index">{{scope.row.period}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="repayDate" label="Scheduled Repayment Date" width="125"></el-table-column>
          <el-table-column label="Principal" width="110">
            <template slot-scope="scope">${{scope.row.repayPrincipal | addThousandSign(2)}}</template>
          </el-table-column>
          <el-table-column label="Interest" width="110">
            <template slot-scope="scope">${{scope.row.repayInterest | addThousandSign(2)}}</template>
          </el-table-column>
          <el-table-column label="Scheduled Total" width="137">
            <template slot-scope="scope">${{scope.row.repaySum | addThousandSign(2)}}</template>
          </el-table-column>
          <el-table-column label="Unpaid amount" width="128">
            <template slot-scope="scope">
              <span style="color:#35C4F9;">${{scope.row.balancedSum | addThousandSign(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="status" prop="repayStatus"></el-table-column>
        </el-table>
        <el-pagination
          v-if="loanAllData.repayInfoList.length > 0"
          class="pament-list-pagination"
          :small="isSmall"
          layout="prev, pager, next"
          :page-count="loanAllData.pageCount"
          :page-size="pageSize"
          :current-page="pageCurrent"
          style="text-align: center;"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>

    <el-dialog class="showManagerDialog" title="Manager info" :visible.sync="showManagerDialog">
      <dl>
        <!--
        <dt><img :src="magerweima"></dt>
        -->
        <dd>
          <div class="name_title">name</div>
          <div class="name_text">{{loanAllData.managerFullName}}</div>
          <div class="name_title">phone</div>
          <div class="name_text">{{loanAllData.managerMobile}}</div>
          <div class="name_title">email</div>
          <div class="name_text">{{loanAllData.managerEmail}}</div>
        </dd>
      </dl>
    </el-dialog>

    <el-dialog
      class="contract dialog"
      top="5%"
      title="contract"
      :visible.sync="showAgreementDialog"
    >
      <div class="contract__dialog-body agreement_contract">
        <img :src="readContract" alt="read" />
      </div>
      <div slot="footer" class="dialog__footer">
        <el-button
          v-if="signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="showSignAgreement"
          style="margin-right:30px;"
        >{{signBtn.text}}</el-button>
        <el-button
          v-if="!signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="downAgreement2"
          style="margin-right:30px;"
        >Download Contract</el-button>
        <!--<a :href="downAgreement" class="down_agreen" download="contract">Download Contract</a>-->
      </div>
    </el-dialog>
    <!-- å¡«å†™æ”¯ç¥¨ä¿¡æ�¯ enter-->
    <el-dialog
      class="showSignDialog"
      top="5%"
      title="Checking Account Information"
      :visible.sync="showCheckDialog"
    >
      <el-form :label-width="'30%'" :model="stepForm" ref="stepForm">
        <el-form-item label="Routing Number">
          <el-input type="tel" placeholder :maxlength="30" v-model="stepForm.routingNumber"></el-input>
        </el-form-item>
        <el-form-item label="Account Number">
          <el-input type="tel" placeholder :maxlength="30" v-model="stepForm.accountNumber"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog__footer">
        <el-button
          class="dialog__footer__confirm-btn sign_btn"
          @click="submitCheckDialog"
          style="margin-right:30px;"
        >NEXT</el-button>
      </div>
    </el-dialog>
    <!-- å¡«å†™æ”¯ç¥¨ä¿¡æ�¯ end-->
    <!-- ä¸Šä¼ é™„ä»¶ enter-->
    <el-dialog class="contract dialog" top="5%" title="Check Pictures" :visible.sync="uploadDialog">
      <el-upload
        class="avatar-uploader"
        action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
        :data="{tokenId: this.userInfo.token}"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        :on-progress="openFullScreen"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avata avatar-uploader-icon" />
        <i
          v-if="!imageUrl"
          class="el-icon-plus avatar-uploader-icon"
          style="background:url(/static/images/checkFront.jpg);background-size:100% 100%;"
        >
          <span style="margin-left:10px;">Front Side</span>
        </i>
      </el-upload>
      <el-upload
        class="avatar-uploader"
        style="margin-top: 25px;"
        action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
        :data="{tokenId: this.userInfo.token}"
        :show-file-list="false"
        :on-success="handleAvatarSuccess2"
        :before-upload="beforeAvatarUpload"
        :on-progress="openFullScreen"
      >
        <img
          v-if="imageUrl2"
          :src="imageUrl2"
          class="avatar avatar-uploader-icon"
          style="display:inline;"
        />
        <i
          v-if="!imageUrl2"
          class="el-icon-plus avatar-uploader-icon"
          style="background:url(/static/images/checkBack.jpg);background-size:100% 100%;"
        >
          <span style="margin-left:10px;">Back Side</span>
        </i>
      </el-upload>
      <div slot="footer" class="dialog__footer">
        <el-button
          class="dialog__footer__confirm-btn sign_btn"
          @click="submitUploadDialog"
          style="margin-right:30px;"
        >NEXT</el-button>
      </div>
    </el-dialog>
    <!-- ä¸Šä¼ é™„ä»¶ end-->

    <el-dialog
      class="showSignDialog"
      title="Confirm the signing of the contract"
      :visible.sync="showSignDialog"
    >
      <el-form>
        <el-form-item>
          <el-input
            placeholder="Sign by inputing your name"
            v-model="fullName"
            auto-complete="off"
            @change="allowSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="tel"
            v-bind:pattern="patternValue"
            onkeypress="return event.keyCode>=48&&event.keyCode<=57"
            placeholder="Your 9 digital only Social Security Number"
            v-model="ssn"
            auto-complete="off"
            :maxlength="9"
            :minlength="9"
            required
            @change="allowSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="email" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class prop="SMSVerificationCode">
          <el-input
            placeholder="VALID CODE"
            v-model="SMSVerificationCode"
            @change="allowSubmit"
            :disabled="isAllowSendingVerifyCode"
            :maxlength="6"
          ></el-input>
          <el-button
            type="primary"
            size="mini"
            class="user-operation__sms-button"
            style="margin-right:5px;margin-top:2px;"
            :loading="isLoading"
            :disabled="SMSVerificationCodeBtn.disabled"
            @click="getSMSVerificationCode"
          >{{SMSVerificationCodeBtn.text}}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSignDialog = false">Cancel</el-button>
        <el-button type="primary" @click="signAgreement" :disabled="allowSubmitBut">OK</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import api from "../../vuex/api";
import placeholders from "../../scripts/placeholders";
import _ from "lodash";
import moment from "moment";
import "webuploader/css/webuploader.css";
import jq from "jquery";
import Webuploader from "webuploader";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      patternValue: "/\d{9}",
      frontApplyId: this.$route.params.frontApplyId,
      mobile: "",
      email: "",
      itemApplyId: "",
      pageCurrent: 1,
      contractId: "",
      pageSize: 10,
      isSmall: true,
      index: 1,
      isLoading: false,
      isAllowSendingVerifyCode: true,
      showManagerDialog: false,
      showAgreementDialog: false,
      showCheckDialog: false,
      uploadDialog: false,
      showSignDialog: false,
      fullName: "",
      allowSubmitBut: true,
      SMSVerificationCode: "",
      money: 0,
      ssn:"",
      signBtn: {
        state: false,
        text: "sign",
        isShow: true
      },
      SMSVerificationCodeBtn: {
        disabled: false,
        text: "get code"
      },
      SMSVerificationCode: [
        {
          required: true,
          trigger: "blur",
          message: "please fill in the received message verification code"
        }
      ],
      SMSVerificationCode: "",
      stepForm: {
        routingNumber: "",
        accountNumber: "",
        checkFront: "",
        checkBack: ""
      },
      imageUrl: "",
      imageUrl2: "",
      fullscreenLoading: false
    };
  },
  computed: {
    ...mapGetters({
      loanAllData: types.GET_LOAN_INFO_DETAIL,
      userInfo: types.GET_USER,
      successModal: types.GET_SUCCESS_MESSAGE,
      failModal: types.GET_FAIL_MESSAGE,
      imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
      redContract: types.GET_CONTRACT_IMAGE_SRC,
      frontItemApplyState: types.FRONT_ITEM_STATE_FRONT
    }),
    magerweima() {
      return `${this.imgSrcPrefix}${this.loanAllData.managerPicture}`;
    },
    readContract() {
      return `${this.redContract}01&loanItemApplyId=${this.loanAllData.itemApplyId}&itemContractSigned=${this.loanAllData.itemContractSigned}`;
    },
    downAgreement() {
      return `/mingdao/mobile/item/pdfSignatureController/readContract.ht?download=true&fileType=PDF&identify=01&isOverseasCustome=N&loanItemApplyId=${
        this.loanAllData.itemApplyId
      }&itemContractSigned=${
        this.loanAllData.itemContractSigned
      }&id=${Math.random()}`;
    },
    toPrepayment() {
      return `/prepayment/${this.loanAllData.itemApplyId}?frontApplyId=${this.$route.params.frontApplyId}`;
    },
    toWholeRepay() {
      return `/wholeRepay/${this.loanAllData.itemApplyId}?frontApplyId=${this.$route.params.frontApplyId}`;
    }
  },
  methods: {
    allowSubmit(val) {
      if (this.fullName != "" && this.SMSVerificationCode != "") {
        this.allowSubmitBut = false;
      } else {
        this.allowSubmitBut = true;
      }
    },
    downAgreement2() {
      //let a = document.createElement("a");
      //a.href = '/mingdao/mobile/item/pdfSignatureController/readContract.ht?download=true&fileType=PDF&identify=01&isOverseasCustome=N&loanItemApplyId=${this.loanAllData.itemApplyId}&itemContractSigned=${this.loanAllData.itemContractSigned}&id=${Math.random()}';
      //a.download = 'contract';
      //a.click();
      window.open(
        `/mingdao/mobile/item/pdfSignatureController/readContract.ht?download=true&fileType=PDF&identify=01&isOverseasCustome=N&loanItemApplyId=${
          this.loanAllData.itemApplyId
        }&itemContractSigned=${
          this.loanAllData.itemContractSigned
        }&id=${Math.random()}`
      );
    },
    changeSignBtn() {
      if (this.loanAllData.itemContractSigned === "-1") {
        this.signBtn.isShow = true;
        this.signBtn.state = false;
        this.signBtn.text = "Sign Contract";
      } else if (this.loanAllData.itemContractSigned === "3") {
        this.signBtn.isShow = false;
        this.signBtn.state = false;
        this.signBtn.text = "Signed";
      } else {
        this.signBtn.isShow = true;
        this.signBtn.state = false;
        this.signBtn.text = "Sign Contract";
      }
    },
    ...mapActions({
      getLoanAllData: types.GET_LOAN_ALL_DATA,
      signAture: types.SIGN_AGREEMENT,
      downContract: types.DOWN_AGREEMENT
    }),
    ...mapMutations({
      setLoanAllData: types.SET_LOAN_ALL_DATA,
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
      setSigned: types.SET_SIGNED
    }),
    //ç‚¹å‡»é¦–é¡µä¸­çš„çš„å�ˆå�ŒæŒ‰é’®
    showAgreement() {
      if (
        this.loanAllData.itemContractSigned === "-1" ||this.loanAllData.itemContractSigned === "1" ||
        this.loanAllData.itemContractSigned === "2" ||
        this.loanAllData.itemContractSigned === "3"
      ) {
        if (this.loanAllData.itemContractSigned === "3") {
          this.showAgreementDialog = true;
        } else {
          this.showAgreementDialog = true;
          //this.uploadDialog = true;
          //this.showCheckDialog = true;
        }
      } else {
        this.setFailModal({
          show: true,
          content:
            "The contract has not yet been generated. Please wait for the customer manager to approve the contract"
        });
      }
    },
    //å¡«å†™äº†æ”¯ç¥¨ä¿¡æ�¯å�Žç‚¹å‡»ä¸‹ä¸€æ­¥
    submitCheckDialog() {
      var _this = this;
      this.isLoading = true;
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyUpdateApplyForCheckInfo.ht",
          {
            tokenId: _this.userInfo.token,
            itemApplyId: this.loanAllData.itemApplyId,
            routingNumber: _this.stepForm.routingNumber,
            accountNumber: _this.stepForm.accountNumber
          }
        )
        .then(res => {
          this.isLoading = false;
          var _data = res.data;
          if (_data.code == 0) {
            _this.showCheckDialog = false;
            _this.uploadDialog = true;
          } else {
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
    },
    //ä¸Šä¼ å®Œé™„ä»¶ä¹‹å�Žçš„æ��äº¤
    submitUploadDialog() {
      var _this = this;
      console.log(this.loanAllData.checkFront);
      if (
        this.loanAllData.checkFront != undefined &&
        this.loanAllData.checkBack != undefined
      ) {
        this.isLoading = true;
        api
          .postForm(
            "/mobile/item/loanItemFrontApply/mgxyUpdateApplyForCheckInfo.ht",
            {
              tokenId: _this.userInfo.token,
              itemApplyId: this.loanAllData.itemApplyId,
              checkFront: _this.loanAllData.checkFront,
              checkBack: _this.loanAllData.checkBack
            }
          )
          .then(res => {
            console.log(res);
            this.isLoading = false;
            var _data = res.data;
            if (_data.code == 0) {
              _this.uploadDialog = false;
              this.showAgreementDialog = true;
            } else {
              this.setAlertMessage({
                show: true,
                content: _data.msg
              });
            }
          });
      } else {
        this.$alert("Please provide your check pictures");
      }
    },

    showSignAgreement() {
      this.showSignDialog = true;
    },
    changePage(currentPage) {
      this.pageCurrent = currentPage;
      this.getData();
    },
    init() {
      api
        .get("/mobile/item/loanItemFrontApply/mgxyApplyDetail.ht", {
          tokenId: this.userInfo.token,
          frontApplyId: this.frontApplyId
        })
        .then(res => {
          if (res.data.code == 0) {
            this.money = res.data.result.totalAmount;
            this.contractId = res.data.result.contractId;
          }
        });
    },
    getData() {
      this.getLoanAllData({
        token: this.userInfo.token,
        frontApplyId: this.frontApplyId,
        pageCurrent: this.pageCurrent,
        pageSize: this.pageSize,
        frontItemApplyState: this.frontItemApplyState,
        itemApplyId: this.itemApplyId
      }).then(res => {
        this.email = this.userInfo.crmCustomerLoginName;
        const data = res.data;
        console.warn(res.data);
        //this.contractId = res.data.contractId;
        if (Number(data.code) === 0) {
          this.setLoanAllData(data.data);
          setTimeout(() => {
            this.changeSignBtn();
          }, 300);
        } else {
          this.setFailModal({
            show: true,
            content: data.result
          });
        }
      });
    },
    signAgreement() {
      const _this = this;
      var fullName = this.fullName;
      var nameArr = fullName.split(" ");
      var firstName = nameArr[0];
      var middleName = "";
      var lastName = "";
      if (nameArr.length > 2) {
        middleName = nameArr[1];
        lastName = nameArr[2];
      } else {
        lastName = nameArr[1];
      }
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyConfirmSignContract.ht",
          {
            tokenId: this.userInfo.token,
            contractId: this.contractId,
            email: this.email,
            validCode: this.SMSVerificationCode,
            firstName: firstName,
            middleName: middleName,
            lastName: lastName,
            ssn:this.ssn
          }
        )
        .then(res => {
          const data = res.data;
          if (data.code === 0) {
            _this.setSuccessModal({
              show: true,
              content: data.msg
            });
            this.showSignDialog = false;
            this.getData();
            _this.changeSignBtn();
          } else if (data.code === 1) {
            this.setFailModal({
              show: true,
              content: data.msg
            });
            _this.changeSignBtn();
          }
        });
    },
    roRepaymentInfo(row) {
      this.$router.push({
        path: `/repaymentInfo/${row.period}/${row.financePayId}/${row.repayStatusCode}`
      });
    },
    // banRepay () {
    //   switch (this.loanAllData.frontApplyState) {
    //     case '32':
    //       return false
    //     default:
    //       return true
    //   }
    // }
    banRepay() {
      switch (this.loanAllData.canPrepay) {
        case "1":
          return false;
        default:
          return true;
      }
    },

    getSMSVerificationCode() {
      this.isLoadingCode = true;
      //alert(321)
      // REGISTRATIONä¸Žå¿˜è®°å¯†ç �çš„çŸ­ä¿¡éªŒè¯�å€’è®¡æ—¶ä¸�éœ€è¦�å…±ç”¨ï¼Œéœ€è¦�å°±å°†ç›¸å…³æ“�ä½œæ‰”åŽ»actionï¼ŒçŽ°åœ¨è¿™æ ·å°±ç›´æŽ¥è¯·æ±‚ï¼Œé™�ä½Žå¤�æ�‚åº¦
      // debugger;
      api
        .getSMSVerificationCodeForEmail({
          email: this.email,
          tokenId: this.userInfo.token
        })
        .then(res => {
          this.isAllowSendingVerifyCode = false;
          const resData = res.data;
          let countDownTime = 420;
          if (Number(resData.code) === 0) {
            this.countDown = setInterval(() => {
              this.isLoadingCode = false;
              this.isCounting = true;
              countDownTime -= 1;
              if (countDownTime !== 0) {
                this.SMSVerificationCodeBtn = {
                  disabled: true,
                  text: `After ${countDownTime} seconds`
                };
              } else {
                this.SMSVerificationCodeBtn = {
                  disabled: false,
                  text: "get code"
                };
                clearInterval(this.countDown);
                this.isCounting = false;
              }
            }, 1000);
          } else {
            this.isLoadingCode = false;
            this.setAlertMessage({
              show: true,
              content: resData.result
            });
          }
        })
        .catch(error => {
          if (error) {
            this.isLoadingCode = false;
          } else {
            this.isLoadingCode = false;
          }
        });
    },

    getSMSVerificationCode1() {
      this.isLoading = true;
      // REGISTRATIONä¸Žå¿˜è®°å¯†ç �çš„çŸ­ä¿¡éªŒè¯�å€’è®¡æ—¶ä¸�éœ€è¦�å…±ç”¨ï¼Œéœ€è¦�å°±å°†ç›¸å…³æ“�ä½œæ‰”åŽ»actionï¼ŒçŽ°åœ¨è¿™æ ·å°±ç›´æŽ¥è¯·æ±‚ï¼Œé™�ä½Žå¤�æ�‚åº¦
      api
        .getSMSVerificationCodeForSign({
          mobile: this.mobile
        })
        .then(res => {
          this.isAllowSendingVerifyCode = false;
          const resData = res.data;
          let countDownTime = 420;
          if (Number(resData.code) === 0) {
            this.countDown = setInterval(() => {
              this.isLoading = false;
              this.isCounting = true;
              countDownTime -= 1;
              if (countDownTime !== 0) {
                this.SMSVerificationCodeBtn = {
                  disabled: true,
                  text: `After ${countDownTime} seconds`
                };
              } else {
                this.SMSVerificationCodeBtn = {
                  disabled: false,
                  text: "get code"
                };
                clearInterval(this.countDown);
                this.isCounting = false;
              }
            }, 1000);
          } else {
            this.isLoading = false;
            this.setAlertMessage({
              show: true,
              content: resData.msg
            });
          }
        })
        .catch(error => {
          if (error) {
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
        });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl =
        "mingdao/platform/system/sysFile/getFileById.ht?fileId=" +
        res.result.fileId;
      this.loanAllData.checkFront = res.result.fileId;
      Loading.service({
        fullscreen: true,
        lock: true
      }).close();
    },
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 =
        "mingdao/platform/system/sysFile/getFileById.ht?fileId=" +
        res.result.fileId;
      (this.loanAllData.checkBack = res.result.fileId),
        Loading.service({
          fullscreen: true,
          lock: true
        }).close();
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      return true;
    },
    openFullScreen() {
      Loading.service({
        fullscreen: true,
        lock: true
      });
    }
  },
  mounted() {
    this.init();
    this.getData();
  }
};
</script>
<style lang="scss">

@media screen and (max-width: 767px) {
  .showSignDialog {
    .el-dialog {
      width: 90% !important;
    }
  }
  .contract-dialog {
    .el-dialog {
      width: 90% !important;
    }
    .declaration__dialog-body {
      height: 50vh;
    }
  }
  .success-modal {
    .el-dialog {
      width: 90% !important;
    }
  }
  .el-message-box {
    width: 90% !important;
  }
}

.showSignDialog {
  .el-dialog {
    width: 485px;
  }
}

.user-operation__sms-button {
  @include vertical-center;
  right: 0;
  border-color: $lighterWaterBlue;
  /*width: 77px;*/
  height: 23px;
  background: $lighterWaterBlue;
  cursor: pointer;
  &:hover,
  &:active,
  &:focus {
    border-color: $lighterWaterBlue;
    background: $lighterWaterBlue;
  }
  &.is-loading {
    @include vertical-center;
  }
}

.showManagerDialog {
  dl {
    overflow: hidden;
    dt {
      width: 159px;
      height: 159px;
      overflow: hidden;
      float: left;
      background: $darkerGray;
      img {
        width: 100%;
        height: 100%;
      }
    }
    dd {
      width: 400px;
      height: 200px;
      float: left;
      .name_title {
        color: $lightWaterBlue;
        font-size: 12px;
        line-height: 24px;
      }
      .name_text {
        color: $personalCenterTitleBlack;
        font-size: 20px;
        margin-bottom: 10px;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog {
    width: 485px;
    height: 300px;
    padding: 0 26px;
    box-sizing: border-box;
    .el-dialog__header {
      padding: 20px 0;
      .el-dialog__headerbtn {
        width: 12px;
        height: 12px;
        color: #a9a9a9;
        margin: -22px -22px 0 0;
      }
    }
    .el-dialog__title {
      font-size: 20px;
      &:after {
        display: block;
        content: "Account Manager";
        font-size: 12px;
        line-height: 22px;
        text-indent: 8px;
        font-weight: normal;
        font-family: "Microsoft YaHei";
      }
    }
  }
}

.loan_detail_h1 {
  height: 35px;
  line-height: 35px;
  margin-bottom: 0;
  overflow: hidden;
  span {
    float: right;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    font-size: 10px;
    font-weight: normal;
    color: $lightSilver;
  }
}

.loan_detail_two_line {
  height: 20px;
  line-height: 20px;
  padding-right: 10px;
}

.loan_detail_first {
  overflow: hidden;
  ul {
    width: 100%;
    height: 156px;
    margin-bottom: 20px;
    box-sizing: border-box;
    overflow: hidden;
    padding: 30px 15px 0 15px;
    border-radius: 7px;
    background: $white;
    li {
      width: 278px;
      height: 95px;
      float: left;
      border-left: 1px solid #eee;
      font-size: 25px;
      color: #59402e;
      font-weight: bold;
      &:first-child {
        border: none;
      }
      &:nth-child(2) {
      }
      em {
        display: block;
        font-size: 17px;
        color: $personalCenterFormLabel;
        line-height: 38px;
        font-style: normal;
        font-family: "FZLanTingHei_GBK";
        &:after {
          display: block;
          color: #3e454d;
          font-size: 12px;
          line-height: 12px;
          font-family: "MyriadPro-Regular";
        }
      }
      strong {
        display: block;
        line-height: 47px;
        font-family: "MyriadPro-Regular", "Microsoft YaHei";
        font-size: 22px;
        color: #374b5e;
        img {
          vertical-align: -3px;
        }
      }
      .btn {
        display: block;
        width: 130px;
        height: 36px;
        margin: 30px auto;
        background: rgba(25, 118, 224, 0.8);
        border-color: #d6dade;
      }
    }
  }
}

.loan_detail_second {
  margin-bottom: 20px;
  overflow: hidden;
  ul {
    width: 100%;
    height: 187px;
    box-sizing: border-box;
    border-radius: 7px;
    padding: 26px 20px;
    background: $white;
    li {
      padding-left: 20px;
      box-sizing: border-box;
      height: 64px;
      overflow: hidden;
      float: left;
      border-right: 1px solid #eee;
      span {
        display: block;
        height: 26px;
        color: #007bff;
        font-size: 12px;
        line-height: 28px;
      }
      strong {
        width: 94%;
        display: block;
        height: 26px;
        color: #34495e;
        font-size: 14px;
        line-height: 28px;
        // overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    li:first-child {
      width: 202px;
      padding-left: 20px;
      border-bottom: 1px solid #eee;
    }
    li:nth-child(2) {
      width: 202px;
      border-bottom: 1px solid #eee;
    }
    li:nth-child(3) {
      width: 202px;
      border-bottom: 1px solid #eee;
    }
    li:nth-child(4) {
      width: auto;
      border-bottom: 1px solid #eee;
      border-right: none;
    }
    li:nth-child(5) {
      width: 202px;
      border: none;
      border-bottom: 1px solid #eee;
    }
    li:nth-child(6) {
      width: 202px;
      padding-top: 14px;
      padding-left: 0;
    }
    li:nth-child(7) {
      width: 154px;
      padding-top: 14px;
      border-bottom: none;
    }
    li:nth-child(8) {
      width: 140px;
      padding-top: 14px;
      border-bottom: none;
    }
    li:nth-child(9) {
      width: 150px;
      padding-top: 14px;
      border-bottom: none;
    }
    li:nth-child(10) {
      width: 184px;
      padding-top: 14px;
      border: none;
    }
  }
}

.loan_detail_three {
  overflow: hidden;
  border-radius: 3px;
  background: $white;
  .table-title {
    height: 45px;
    overflow: hidden;
    line-height: 50px;
    font-size: 16px;
    color: #34495e;
    text-indent: 18px;
    .btn_cont {
      display: inline-block;
      float: right;
      margin-right: 10px;
      .btn {
        display: inline-block;
        margin-right: 13px;
        width: 87px;
        height: 28px;
        line-height: 26px;
        text-indent: 0;
        text-align: center;
        border-radius: 3px;
        font-size: 14px;
        border: 1px solid $orange;
        color: $orange;
        cursor: pointer;
        background-color: transparent;
        &[disabled] {
          cursor: not-allowed;
          box-shadow: none;
          background-color: transparent;
          opacity: 0.65;
        }
      }
    }
  }
  .pament-list-pagination {
    margin: 15px auto;
  }
  .tips_info {
    position: relative;
    height: 50px;
    color: #00c0ff;
    font-size: 14px;
    top: -2px;
    &:before {
      margin-right: 5px;
    }
  }
}

.agreement_contract {
  height: auto;
  min-height: 270px;
  img {
    width: 100%;
    height: auto;
  }
}

.sign_btn:hover {
  color: $white;
}

.down_agreen {
  display: inline-block;
  border: 0;
  min-width: 120px;
  height: 45px;
  border-radius: 3px;
  font-size: 16px;
  color: #fff;
  line-height: 45px;
  text-align: center;
  background: #ff8b38;
}

.el-table .cell {
    word-break: break-word;
}

@media (max-width: 768px) {
  .loan_detail_three {
    display: none;
  }
  .loan_detail_first ul {
    height: auto;
    li {
      border: none;
      width: 100%;
      em {
        font-size: 24px;
      }
    }
  }
  .mobile-hide-button {
    display: none;
  }
  .loan_detail_second ul li{
    border-right: none;
    // width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// LoanDetail.vue?036cbfd7